import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import *  as firebase from 'firebase';
import { map } from 'rxjs/operators';
import { AuthServiceProvider } from '../auth-service/auth-service';

/*
handles the data base read and writes
*/
@Injectable()
export class DataBaseProvider {

  constructor(private afs: AngularFirestore) {
  }

  /**
   * if there user is not initilized the
   * the user is initialized with minimum information
   * start the index for the estimate with zero
   * @param userKey 
   * @param email 
   */
  initializeUser(userKey, email): Promise<any> {
    const initData = { email: email, billNumber: 0 }
    return this.afs.doc(`users/${userKey}`).set(initData);
  }

  getUserInfo(userKey): Observable<any> {
    return this.afs.doc(`users/${userKey}`).valueChanges();
  }

  updateUserInfo(userInfo: any, userKey): Promise<any> {
    return this.afs.doc(`users/${userKey}`).update(userInfo);
  }

  /**
   * Returns the key for the bill 
   * @param billInfo 
   */
  insertBillInfo(billInfo): Promise<any> {
    billInfo.timeStamp = firebase.firestore.FieldValue.serverTimestamp();
    console.log('the data attempting to get inserted', billInfo);
    return this.afs.collection(`billings`).add(billInfo)
  }

  getBillingInfo(billKey): Observable<any> {
    return this.afs.doc(`billings/${billKey}`).valueChanges();
  }

  // returns the list of bills for a user
  getBillList(userKey): Observable<any> {
    return this.afs.collection(`billings`, ref => ref.where('owner', '==', `${userKey}`)).snapshotChanges().pipe(map((collectionData: any) => {
      return collectionData.map((documentData: any) => {
        const key = documentData.payload.doc.id;
        return { key, ...documentData.payload.doc.data() };
      });
    }));
  }

  // get the list of all users (Admin)
  getAllUsers(): Observable<any> {
    return this.afs.collection(`users`).snapshotChanges().pipe(map((collectionData: any) => {
      return collectionData.map((documentData: any) => {
        const key = documentData.payload.doc.id;
        return { key, ...documentData.payload.doc.data() };
      });
    }));
  }

  /**
   * Returns the admin details observebale for
   * a user key
   * @param userKey 
   */
  isAdminUser(userKey: string): Observable<any> {
    return this.afs.doc(`admins/${userKey}`).valueChanges();
  }

  /**
   * Returns the Superadmin details observebale for
   * a user key
   * @param userKey 
   */
  isSuperAdminUser(userKey: string): Observable<any> {
    return this.afs.doc(`super-admins/${userKey}`).valueChanges();
  }

  /**
   * Returns the observbale of tenant information
   * @param userKey 
   */
  getTenantInfo(userKey: string): Observable<any> {
    return this.afs.doc(`tenantInfo/${userKey}`).valueChanges();
  }

  /**
   * Returns the list of user logs
   */
  getTheListOfLogs(userKey): Observable<any> {
    return this.afs.collection(`dailyActivity`, ref => ref.where('ownerKey', '==', `${userKey}`)).snapshotChanges().pipe(map((collectionData: any) => {
      return collectionData.map((documentData: any) => {
        const key = documentData.payload.doc.id;
        return { key, ...documentData.payload.doc.data() };
      });
    }));
  }

  updateActivityLog(activityLog) {
    activityLog.updated = firebase.firestore.FieldValue.serverTimestamp();
    return this.afs.doc(`dailyActivity/${activityLog.key}`).update(activityLog);
  }

  /**
   * insert new activity logs to the system
   * @param activityLog 
   */
  insertActivityLog(activityLog): Promise<any> {
    activityLog.created = firebase.firestore.FieldValue.serverTimestamp();
    return this.afs.collection(`dailyActivity`).add(activityLog);
  }

  getActivityLogs(startTime, endTime): Observable<any> {
    return this.afs.collection(`dailyActivity`, ref => ref.where('date', '>=', startTime)
      .where('date', '<=', endTime)).snapshotChanges().pipe(map((collectionData: any) => {
        return collectionData.map((documentData: any) => {
          const key = documentData.payload.doc.id;
          return { key, ...documentData.payload.doc.data() };
        });
      }));
  }

  getActivityLogsForOneDay(date): Observable<any> {
    return this.afs.collection(`dailyActivity`, ref => ref.where('date', '==', date)).snapshotChanges().pipe(map((collectionData: any) => {
      return collectionData.map((documentData: any) => {
        const key = documentData.payload.doc.id;
        return { key, ...documentData.payload.doc.data() };
      });
    }));
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-base/data-base.ts